import { Button } from '@progress/kendo-react-buttons';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { TextArea } from '@progress/kendo-react-inputs';
import * as React from 'react';
import { fetchApi } from '../../services/api';

interface Props {
  QuoteID: number;
  CloseDialog: () => void;
}

type State = {
  Reason: string;
  Note: string;
  Loading: boolean;
}

const reasons = [
  'Incorrect O/D Pair',
  'Incorrect Equipment Type',
  'Incorrect Pick Up/Delivery Times',
  'Missed Special Requirements',
  'Incorrect BillTo',
];

export class FlagMisquoteDialog extends React.Component<Props, State> {

  constructor(props: Props) {
    super(props);

    this.state = {
      Reason: '',
      Note: '',
      Loading: false,
    }

    this.flagMisquote = this.flagMisquote.bind(this);
  }

  private flagMisquote() {
    this.setState({ Loading: true });
    fetchApi('/api/Quote/FlagMisquote', {
      quoteID: this.props.QuoteID,
      reason: this.state.Reason,
      note: this.state.Note,
    }, 'POST')
      .then(() => {
        this.props.CloseDialog();
      })
      .catch(() => {
        this.setState({ Loading: false });
        alert('Unable to send flag email.');
      });
  }

  public render() {
    return (
      <Dialog title="Flag Misquoted" onClose={this.props.CloseDialog} className="dialog-w525">
        <label className="font-weight-bold mb-1 d-block">What was set up wrong?</label>
        <DropDownList
          data={reasons}
          value={this.state.Reason || null}
          defaultItem="Select a reason..."
          onChange={(e) => this.setState({ Reason: e.value })}
        />
        <label className="font-weight-bold mt-3 mb-1 d-block">Quick description</label>
        <TextArea
          rows={4}
          maxLength={500}
          placeholder="Optional additional details..."
          value={this.state.Note}
          onChange={(e) => this.setState({ Note: e.value as string })}
        />
        <DialogActionsBar>
          <Button onClick={this.props.CloseDialog}>Cancel</Button>
          <Button
            themeColor="warning"
            disabled={!this.state.Reason || this.state.Loading}
            onClick={this.flagMisquote}
          >
            Flag Misquoted
          </Button>
        </DialogActionsBar>
      </Dialog>
    );
  }
}

export default FlagMisquoteDialog;
